<template>
    <section class="checklist-item">
        <loading :show="loading">
        </loading>
        <div class="row">
            <div class="col-md-3">
                <div class="card row">
                    <div class="card-header">
                        Select group checklist-item
                    </div>
                    <div class="card-body">
                        <fieldset role="group" class="b-form-group form-group">
                            <div role="group" class="">
                                <Tree :data="data" cross-tree="cross-tree" class="scroll">
                                    <div slot-scope="{data, level, store}">
                                        <template v-if="!data.isDragPlaceHolder">
                                            <div class="node">
                                                <span class="pull-right link" @click="select(data)">
                                                    <i class="fa fa-plus"></i>
                                                </span>
                                                <span> <span v-html="data.index"></span> - {{ data.header }}</span>
                                            </div>
                                        </template>
                                    </div>
                                </Tree>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
            <div class="col-md-9 pr-0">
                <div class="card">
                    <div class="card-header">
                        Checklist - item ( <b>checklist:{{ checklist.name }}</b> )
                        <div class="card-actions">
                            <a style="cursor: pointer" @click="info()">
                                <small class="text-muted">
                                    <i class="fa fa-info"></i> info</small>
                            </a>
                            <a style="cursor: pointer" @click="copyChecklist">
                                <small class="text-muted">
                                    <i class="fa fa-copy"></i> copy</small>
                            </a>
                            <a style="cursor: pointer" @click="save()">
                                <small class="text-muted">
                                    <i class="fa fa-save"></i> Save</small>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4" style="border-right: #ddd 1px solid">
                                <Tree :data="chooice" cross-tree="cross-tree" class="scroll">
                                    <div slot-scope="{data, level, store}">
                                        <template v-if="!data.isDragPlaceHolder">
                                            <div class="node" v-bind:class="{ select: data.id == select_group.id }">
                                                <span class="pull-right link" @click="removeGroup(data)">
                                                    <i class="fa fa-remove"></i>
                                                </span>
                                                <span> {{ data.chk_items ? data.chk_items.length : '' }}</span>
                                                <span @click="selectChecklistItem(data)" class="link"> <span
                                                        v-html="data.index"></span> - {{ data.header }}</span>
                                            </div>
                                        </template>
                                    </div>
                                </Tree>
                            </div>
                            <div class="col-md-8">
                                <OverviewChk :checklist="checklist" :team="checklist_users" v-if="!select_group.id" />
                                <table-item v-if="select_group.id" :items="select_group.chk_items" :group="select_group"
                                    @destroyItem="destroyItem" @addItem="addItem" @addItemSuccess="addItemSuccess">
                                    {{ select_group.index }} {{ select_group.header }}
                                </table-item>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <copy-checklist ref="copyChecklistShow" @copy="copy"></copy-checklist>
    </section>
</template>
<script>
import { DraggableTree } from 'vue-draggable-nested-tree'
import OverviewChk from '../view/overviewChk'
import Helper from './helper'
import lodash from 'lodash'
import TableItem from './table-item'
import swal from 'sweetalert'
import CopyChecklist from './copy-checklist'
import { getAssessmentTeam } from '@/service/Apis'
import HelperR from '@/Helper'
export default {
  name: 'checklist-item',
  components: { Tree: DraggableTree, OverviewChk, TableItem, CopyChecklist },
  props: [],
  data () {
    return {
      loading: false,
      group_checklist_items: [],
      normalizer (node) {
        return {
          id: node.id,
          label: node.index + node.header,
          children: node.children
        }
      },
      chooice: [],
      select_group: {},
      checklistId: this.$route.params.checklist_id,
      checklist_users: []
    }
  },
  computed: {
    data () {
      return this.$store.getters['GroupChecklistItem/getListGroupChecklistItem']
    },
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    }
  },
  mounted () {
    Promise.all([
      this.data.length === 0 ? this.$store.dispatch('GroupChecklistItem/getListGroupChecklistItem', { page: 1, per_page: 'all' }) : '',
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.checklistId } }),
      this.$store.dispatch('Checklist/duplicateChecklist', { checklist: { id: this.checklistId } })
    ]).then(res => {
      this.data2 = []
      var tam = [...res[0]]
      tam.forEach(element => {
        this.data2.push(Object.assign({}, element))
      })
      this.chooice = this.$store.getters['Checklist/getGroupOfChecklist']
    }).catch(errors => {
      console.log(errors)
    })
    this.fetchTeam()
  },
  methods: {
    async fetchTeam () {
      const res = await getAssessmentTeam(this.checklistId)
      this.checklist_users = HelperR.sortTeam(res.data)
    },
    select (data) {
      this.select_group = {}

      this.$store.dispatch('GroupChecklistItem/showGroupChecklistItem', { group_checklist_item: data, status: this.$status.APPROVAL }).then(res => {
        var parent = []
        var chooice = []
        this.data.forEach(element => {
          parent = parent.concat(Helper.getUnNestedChildren(element))
        })
        this.chooice.forEach(element => {
          chooice = chooice.concat(Helper.getUnNestedChildren(element))
        })
        var tam = lodash.orderBy(Helper.getDiff(Helper.getParent(res.id, parent).concat(Helper.getUnNestedChildren(res)), chooice), 'id')
        this.chooice = Helper.getNestedChildren(tam, 0)
      }).catch(errors => {
        console.log(errors)
      })
    },
    selectChecklistItem (data) {
      this.select_group = data
    },
    removeGroup (data) {
      this.select_group = {}
      var chooice = []
      this.chooice.forEach(element => {
        chooice = chooice.concat(Helper.getUnNestedChildren(element))
      })
      var index = lodash.findIndex(chooice, ['id', data.id])
      chooice.splice(index, 1)
      this.chooice = Helper.getNestedChildren(chooice, 0)
    },
    info () {
      this.select_group = {}
    },
    destroyItem (item) {
      var index = lodash.findIndex(this.select_group.chk_items, ['id', item.id])
      var tamp = this.select_group.chk_items[index]
      item.destroy = true
      this.select_group.chk_items.splice(index, 1, tamp)
    },
    addItemSuccess (items) {
      this.select_group.chk_items = items
    },
    addItem (item) {
      var index = lodash.findIndex(this.select_group.chk_items, ['id', item.id])
      var tamp = this.select_group.chk_items[index]
      item.destroy = false
      this.select_group.chk_items.splice(index, 1, tamp)
    },
    copyChecklist () {
      Promise.all([
        this.organizations.length === 0 ? this.$store.dispatch('Organization/getData', { page: 1, per_page: 'all' }) : ''
      ]).then(res => {
        this.$refs.copyChecklistShow.show()
      }).catch(errors => {
      })
    },

    copy (checklist) {
      this.$store.dispatch('Checklist/duplicateChecklist', { checklist }).then(res => {
        this.chooice = this.$store.getters['Checklist/getGroupOfChecklist']
        this.$refs.copyChecklistShow.hide()
      }).catch(errors => {
      })
    },

    save () {
      var groups = []
      var items = []
      this.chooice.forEach(element => {
        groups = groups.concat(Helper.getUnNestedChildren(element))
      })
      groups.forEach(element => {
        if (element.chk_items) {
          Object.values(element.chk_items).forEach(item => {
            if (!item.destroy) {
              items.push(item.id)
            }
          })
        }
      })
      if (items.length) {
        this.$store.dispatch('Checklist/addChecklistItem', { checklist: this.checklist, checklist_items: items }).then(res => {
          this.$notify({
            group: 'success',
            title: this.$t('notify.notify'),
            text: this.$t('notify.update_success')
          })
          this.$router.push('/checklist/list')
        }).catch(errors => {
        })
      } else {
        swal({
          title: 'Checklist rỗng bạn có chắc chắn muốn thoát ?',
          icon: 'warning',
          buttons: true,
          dangerMode: true
        }).then((willDelete) => {
          if (willDelete) {
            this.$router.push('view')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
#app {
    padding: 50px;
}

.node {
    border: 1px solid #ddd;
    padding: 7px;
}

.node:hover {
    background: #ddd
}

.select {
    background: #ddd
}

label {
    font-weight: 700
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/checklist-item/index.vue